import React, { createContext, ReactNode ,useMemo} from 'react'
import { noop } from 'lodash'
import { TabInterface } from '@ui-kit'
import {
  DataTypeStore,
  LayoutResponseType,
  WorkflowDefinitionsListType,
} from '@app-store'
import { FieldValues } from 'react-hook-form'

interface CallInteractionContextType {
  isEditMode?: Record<number, boolean>
  handleIsEditMode?: (value: Record<number, boolean>) => void
  modal?: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }
  handleModal?: (value: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }) => void
  tabs?: TabInterface[]
  setTabs?: React.Dispatch<React.SetStateAction<TabInterface[]>>
  viewEntityRecord?: DataTypeStore
  workflowList?: WorkflowDefinitionsListType[]
  tabIndexOffset?: number
  setTabOffset?: React.Dispatch<React.SetStateAction<number>>
  layoutInfo?: {
    layout?: LayoutResponseType | null
    recordData?: FieldValues | null
  }[]
  setLayoutInfo?: React.Dispatch<
    React.SetStateAction<
      {
        layout?: LayoutResponseType | null
        recordData?: FieldValues | null
      }[]
    >
  >
}

interface CallInteractionContextPropsType {
  children: ReactNode
  isEditMode?: Record<number, boolean>
  handleIsEditMode?: (value: Record<number, boolean>) => void
  modal?: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }
  handleModal?: (value: {
    message: string
    state: boolean
    onYesClick?: () => void
    onCancelClick?: () => void
  }) => void
  tabs: TabInterface[]
  setTabs: React.Dispatch<React.SetStateAction<TabInterface[]>>
  viewEntityRecord?: DataTypeStore
  workflowList: WorkflowDefinitionsListType[]
  tabIndexOffset?: number
  setTabOffset?: React.Dispatch<React.SetStateAction<number>>
  layoutInfo?: {
    layout?: LayoutResponseType | null
    recordData?: FieldValues | null
  }[]
  setLayoutInfo?: React.Dispatch<
    React.SetStateAction<
      {
        layout?: LayoutResponseType | null
        recordData?: FieldValues | null
      }[]
    >
  >
}

export const CallInteractionContext = createContext<CallInteractionContextType>(
  {}
)

const CallInteractionContextProvider: React.FC<
  CallInteractionContextPropsType
> = ({
  children,
  isEditMode = {},
  handleIsEditMode = noop,
  modal,
  handleModal,
  setTabs,
  tabs,
  viewEntityRecord,
  workflowList,
  tabIndexOffset,
  setTabOffset,
  layoutInfo,
  setLayoutInfo,
}) => {
  const value = useMemo(
    () => ({
      isEditMode,
      handleIsEditMode,
      modal,
      handleModal,
      setTabs,
      tabs,
      viewEntityRecord,
      workflowList,
      tabIndexOffset,
      setTabOffset,
      layoutInfo,
      setLayoutInfo,
    }),
    [
      isEditMode,
      handleIsEditMode,
      modal,
      handleModal,
      setTabs,
      tabs,
      viewEntityRecord,
      workflowList,
      tabIndexOffset,
      setTabOffset,
      layoutInfo,
      setLayoutInfo,
    ]
  )
  return (
    <CallInteractionContext.Provider value={value}>
      {children}
    </CallInteractionContext.Provider>
  )
}

export default CallInteractionContextProvider
